import React, {useState} from "react";
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UISelect from 'components/selectbox/UISelect';
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from "utils/CommonUtil";
import UIUtils from "utils/UIUtils";
import StringUtil from 'utils/StringUtil';
import DateUtil from "utils/DateUtil";
import ValidationUtil from "common/validation/util/ValidationUtil"
import message from "common/message/source/MessageSource";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {
	const modaladm6313 = useToggleState({});

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();
	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20)  

	const [bizInfo, setBizInfo] = useState({});
	const [bizCd, setBizCd] = useState("");
	const [bizNm, setBizNm] = useState("");
	const [bizShortNm,setBizShortNm] = useState('')
	const [option1, setOption1] = useState('1');
	const [personId, setPersonId] = useState('');
	const [personNm, setPersonNm] = useState('');
	const [userTpCd, setUserTpCd] = useState('');
	const [modalIsOpen, setModalIsOpen] = useState(false);
	
	const [bizStDate,setBizStDate] = useState(new Date())
	const [bizEnDate,setBizEnDate] = useState(new Date())
	
	const [funPurUseCd,setFunPurUseCd] = useState('')
	const [funPurUseNo,setFunPurUseNo] = useState('')
	
	const [middCorpPermYn,setMiddCorpPermYn] = useState('')
	
	const [donReceIssContCd,setDonReceIssContCd] = useState('')
	const [bizMainMangUserid,setBizMainMangUserid] = useState('')
	const [bizMainMangUserNm,setBizMainMangUserNm] = useState('')
	const [bizDeptMangUserid,setBizDeptMangUserid] = useState('')
	const [bizDeptMangUserNm,setBizDeptMangUserNm] = useState('')
	
	const [notes,setNotes] = useState('')
	const [donReceIssKey,setDonReceIssKey] = useState('')
	const [regUserId,setRegUserId] = useState('');
	const [regUserNm,setRegUserNm] = useState('');
	const [modiUserId,setmodiUserId] = useState('');
	const [modiUserNm,setmodiUserNm] = useState('');
	const [regDate,setRegDate] = useState('');
	const [modiDate,setModiDate] = useState('');
	const [mode , setMode] = useState('');
	const [readOnly , setReadOnly] = useState(true);
	const [loadFinish,setLoadFinish] = useState(false);

	/*
	사업용도(소분류) > 사업분야로 항목명 변경(TO-BE) 5-1 참고단, 항목값들은 현행화 필요.
	과제신청시 과제분야를 의미함.
	*/
	const [bizKindCd1,setBizKindCd1] = useState(''); //과제분류 대 코드

	//초기 데이터 설정
	let totalCnt:number = 0;
	let rowCnt:number = 0;
	
	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": 20,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0"
				
			},
			Def:{
				Row:{
				//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"}
			],
			"Cols": [
			{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
			{"Header": "이름","Type": "Text","Name": "PERSON_NM","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
			{"Header": "부서","Type": "Text","Name": "DEPT_NM","RelWidth": 2,"Align": "Center","CanEdit": "0"},
			{"Header": "아이디","Type": "Text","Name": "LOGIN_NM","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
			{"Header": "휴대폰번호","Type": "Text","Name": "HP_NO","RelWidth": 2.5,"Align": "Center","CanEdit": "0","CustomFormat": "###-####-####"},
			{"Header": "이메일주소","Type": "Text","Name": "EMAIL_ADRES","RelWidth": 2.5,"Align": "Center","CanEdit": "0"},
			]
				 
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch('search');
				setOption1("1");
			},
			//시트 클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				var sheet = evtParam.sheet;
				var row = sheet.getFocusedRow();
				let vPERSON_ID = row["PERSON_ID"];
				let vPERSON_NM = row["PERSON_NM"];

				if(userTpCd == "M"){
				    setBizMainMangUserid(vPERSON_ID);
					setBizMainMangUserNm(vPERSON_NM);
				}else if(userTpCd == "D"){
					setBizDeptMangUserid(vPERSON_ID);
					setBizDeptMangUserNm(vPERSON_NM)
				}else{
					setPersonId(vPERSON_ID);
					setPersonNm(vPERSON_NM);
				}

				//모달 시트 닫기
				modalClose();
				
		    },	
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;
		
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
				_data = JSON.stringify(d.slice(0, 20), null, 2);
				_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
				_data = JSON.stringify(d, null, 2);
				}
				
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		        //@ts-ignore
				if (currentPage != -1 && currentPage != page) {
				  makePageIndex(page);
				}
				
			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//조회 데이터
		'data':[]
	}
	
	//====== 그리드 공통 부  END
	
	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
	try {
		if (tp == null) {
			//@ts-ignore
			currentPage = -1;
			return;
		}

		// @ts-ignore
		if (document.getElementById('pageNavi').firstChild) {
		// @ts-ignore
		document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
		}

		// @ts-ignore
		currentPage = tp;
		// @ts-ignore
		let sr = totalCnt // 전체 조회 건수
		// @ts-ignore
		let page = rowCnt; // 페이지당 레코드 수
		let thispage = tp; // 현재 페이지
		let pagecnt = 5; // 한번에 표시할 페이지 개수
		let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
		let li, tt, a;
		let ul = document.createElement('DIV');
		// @ts-ignore
		ul.style.textAlign = 'center';

		let k = 1;

		if (thispage !== 1) {
		let ul_sub = document.createElement('DIV');
		ul_sub.className ="group";
		li = document.createElement('Button');
		li.className = 'item first';
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		tt = document.createTextNode('<<');
		addEventHandler(li, 'click', pageMove, 1);
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub.appendChild(li)
		ul.appendChild(ul_sub);
		
		li = document.createElement('Button');
		li.className = 'item prev';
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		addEventHandler(li, 'click', pageMove, tp - 1);
		tt = document.createTextNode('<');
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub.appendChild(li)
		ul.appendChild(ul_sub);
		}

		sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
		let ul_sub2 = document.createElement('DIV');
		ul_sub2.className ="group";
		for (let i = sr; i < (sr + pagecnt); i++) {
		if (i <= lastpage) {
			li = document.createElement('Button');
			li.className ="item";
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			tt = document.createTextNode(String(i));
			addEventHandler(li, 'click', pageMove, i);
			if (i === tp) {
			li.className ="item active";
			}
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub2.appendChild(li);
			ul.appendChild(ul_sub2);
		}
		}

		if (thispage < lastpage) {
		let ul_sub3 = document.createElement('DIV');
		ul_sub3.className ="group";	
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		li = document.createElement('Button');
		li.className = 'item next';
		tt = document.createTextNode('>');
		addEventHandler(li, 'click', pageMove, tp + 1);
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub3.appendChild(li);
		ul.appendChild(ul_sub3);
		
		li = document.createElement('Button');
		li.className = 'item last';
		tt = document.createTextNode('>>');
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		addEventHandler(li, 'click', pageMove, lastpage);
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub3.appendChild(li);
		ul.appendChild(ul_sub3);
		}

		ul.className = 'pg';
		// @ts-ignore
		document.getElementById('pageNavi').appendChild(ul);
	} catch (ex) {
		// @ts-ignore
		console.log(ex.message);
	}
	}
	
	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);
	}
	
	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
	if (obj.addEventListener) { // all browsers except IE before version 9
		obj.addEventListener(evtName, function () { func(param); }, false);
	} else if (obj.attachEvent) { // IE before version 9
		obj.attachEvent('on' + evtName, function () { func(param); });
	}
	}

	function dateLpad(num){
		if(num == 0){
			num = "0"+num;
		}
		else if(num+''.length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {
		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let hours = date.getHours();
		let mm = date.getMinutes();
		let ss = date.getMilliseconds();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+') ' + dateLpad(hours) +":" + dateLpad(mm)+":"+dateLpad(ss);
	}
	

	async function initCall(bizCd){
		let param = {
			"BIZ_CD": bizCd
		};

		const response:any = await CommonUtil.execute({
			url:'adm_6311_detail',
			data: param
		})

		const result = response.REC;
		setBizInfo(result);

		setBizCd(result.BIZ_CD);
		setBizNm(result.BIZ_NM);
		setBizShortNm(result.BIZ_SHORT_NM);
		setBizStDate(new Date(Number(result.BIZ_ST_DATE)));
		setBizEnDate(new Date(Number(result.BIS_EN_DATE)));
		setFunPurUseCd(result.FUN_PUR_USE_CD);
		setMiddCorpPermYn(result.MIDD_CORP_PERM_YN);
		setFunPurUseNo(result.FUN_PUR_USE_NO);
		setDonReceIssContCd(result.DON_RECE_ISS_CONT_CD);
		setBizMainMangUserid(result.BIZ_MAIN_MANG_USERID);
		setBizMainMangUserNm(result.BIZ_MAIN_MANG_USER_NM);
		setBizDeptMangUserid(result.BIZ_DEPT_MANG_USERID);
		setBizDeptMangUserNm(result.BIZ_DEPT_MANG_USER_NM);
		setNotes(result.NOTES);
		setDonReceIssKey(result.DON_RECE_ISS_KEY);
		setRegUserNm(result.REG_USER_NM);
		setRegUserId(result.REG_USERID);
		setRegDate(dateToStr(result.REG_DATE));
		
	};

	//검색 
    async function doSearch(sAction:string) {
		let param = {}
		if(sAction =="search"){
			param = {
				"PERSON_NM": personNm
				,"OPTION1": $('#tpCd').val()
				,"USER_TP_CD":userTpCd
			};
		}

		const response:any = await CommonUtil.execute({
			url:'popup_selectPersonList',
			data: param
		})
	
			
		//전체데이터 
		let result = response.LIST;

		if(result.length > 0){

			//전체ROW개수 
			totalCnt = result.length;
			setTotalRowCnt(result.length );
			
			// 시트에 데이터를 넣습니다.
			ib.data = result;
			// @ts-ignore	
			sheet.loadSearchData(result);  //data 로딩 처리 
			// @ts-ignore	
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore	
			makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
		
		}
		
}//검색

	

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(bizInfo).length != 0){
			return bizInfo[name];
		}else{
			return '';
		}
	};


	//취소하면 다시 상세로 이동
	const bizInfoCancel = function (){
        let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
		pathname: './adm6311',
		state: { data: receivedData }
		});
	}

	//수정 저장
	async function bizInfoUpdate (){
		
		if(bizNm =="" || bizShortNm == "" || funPurUseNo =="" || funPurUseNo ==""
			|| bizMainMangUserid == ""
		){
			await UIUtils.alert('필수 입력값 입력해주세요.');
			return;
		}

		// if (!ValidationUtil.checkAll()) {
		// 	return;
		// }

		let param = {
			"BIZ_CD":bizCd
			,"BIZ_NM":bizNm
			,"BIZ_ST_DATE":DateUtil.toDateFormat(bizStDate, "YYYY-MM-DD HH:mm:ss")
			,"BIS_EN_DATE":DateUtil.toDateFormat(bizEnDate, "YYYY-MM-DD HH:mm:ss")
			,"BIZ_SHORT_NM":bizShortNm
			,"FUN_PUR_USE_NO":funPurUseNo
			,"FUN_PUR_USE_CD":funPurUseCd
			,"DON_RECE_ISS_KEY":donReceIssKey
			,"DON_RECE_ISS_CONT_CD":donReceIssContCd
			,"BIZ_MAIN_MANG_USERID":bizMainMangUserid
			,"BIZ_DEPT_MANG_USERID":bizDeptMangUserid
			,"MIDD_CORP_PERM_YN":middCorpPermYn
			,"NOTES":notes
			,"MODI_USERID":""

		}

		//console.log("param  : "+ JSON.stringify(param));

		if(await UIUtils.confirm('저장하시겠습니까?')){
			
			const response:any = await CommonUtil.execute({
				url:"adm_6314_bizInfoUpdate",
				data: param
			})

			
			if (!response.COMMON_HEAD.ERROR) {
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));

				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
				pathname: './adm6311',
				state: { data: receivedData }
				});	
			}
		}
	
	}

	//목록으로 
	const goList = () =>{
		history.push({
			pathname: './adm6310',  
			state: { data: receivedData }
		});
	}

	//모달 오픈 후 IBSheet오픈
	async function onAfterOpen() {
        ib.create();
        
		return () => {
	      // @ts-ignore
	      IBSheet.disposeAll(true);
	    }            
	
	}
	
	// 모달 오픈
	async function modalOpen(tpCd:string) {
		setUserTpCd(tpCd);
		setModalIsOpen(true)
	}

	//모달 닫기
	async function modalClose() {
		setModalIsOpen(false);
		setPersonNm('');
		setUserTpCd('');
		setOption1('');
		// @ts-ignore
		IBSheet.sheet.dispose();
		
	  }

	  	
	// 사용자 유형 선택값 처리
	const handleSelect = (e) => {
		if(e.target.name === 'tpCd'){  //페이지 건수별로 보기
			setOption1(e.target.value);
		 } else if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
  
			rowCnt = e.target.value;
			// @ts-ignore
			IBSheet.disposeAll(true);		  
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();
		}
	};

	//기부금 사용용도에 따른 과제 대분류 가져오기
	async function changeFunPurUseNo(code:string) {
		let value = CommonUtil.suppSizeMappingVal(code);
		codeDataStore.read("common.suppSizeA," + value).then(() => {
			setFunPurUseNo(value);
		});
	}

	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read("/common/yesNoYN",
        "[FPUC]",
        "[FPUN]").then(() => {
			setLoadFinish(true);

			 //넘어온 파라미터 바인딩   
			if(receivedData != undefined){
				let bizCd = StringUtil.defaultString(receivedData.vBIZ_CD);
				setBizCd(bizCd)
				localStorage.setItem("bizCd", bizCd);
			}
			
			let bizCdStorage = localStorage.getItem("bizCd");
			if (bizCdStorage != null) {
				setBizCd(bizCdStorage);
			}
			
			//상세데이터 가지고 오기
			initCall(bizCdStorage);

		});

	}, [])//effect


	if(!loadFinish)
		return (
			<PageLoading />
		)
	else

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">사업관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">사업 수정</h1>

						<form className="fo fo-col3" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">사업코드</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={bizCd} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사업명</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={bizNm} valueChanged={(value) => setBizNm(String(value))} rules={["required"]}	/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사업약칭</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={bizShortNm} valueChanged={(value) => setBizShortNm(String(value))} rules={["required"]}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사업시작일</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={bizStDate} valueChanged={(value) => setBizStDate(value)} rules={["required"]}/>
										</div>	
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사업종료일</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
												<UIDatePicker className="hz-item" value={bizEnDate} valueChanged={(value) => setBizEnDate(value)} rules={["required"]}/>
											</div>	
									</div>
								</div>
								

								<div className="fo-item req">
									<p className="fo-key">중견기업허용여부</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
											firstName={"sel"}
											codeData={codeDataStore.get("/common/yesNoYN")}
											value={middCorpPermYn}
											valueChanged={(value) =>setMiddCorpPermYn(String(value))}
											rules = {[(value: any) => {
												if (value == "선택") {
													return `선택해 주세요.`;
												}
												return undefined;
											}]}
											/>
										</div>										
									</div>
								</div>
								
								<div className="fo-item req">
									<p className="fo-key">기금사업용도</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[FPUC]")}
												value={funPurUseCd}
												valueChanged={
													(value) => {
														setFunPurUseCd(String(value))
														changeFunPurUseNo(String(value));
														
 													}
												}
												firstName={"sel"}
											/>
											
											{/* <UISelect
												firstName={"sel"}
												codeData={codeDataStore.get("[FPUC]")}
												value={funPurUseCd}
												valueChanged={(value) => setFunPurUseCd(String(value))}
												
											/> */}
										</div>	
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업분야</p>
									<div className="fo-value">
									<div className="sl sl-md w100p">
											{/* <UISelect
												codeData={codeDataStore.get("common.suppSizeA," + funPurUseNo)}
												value={bizKindCd1}
												valueChanged={(value) => setBizKindCd1(value)}
												firstName={"sel"}
											/> */}
											<UISelect
												firstName={"sel"}
												codeData={codeDataStore.get("[FPUN]")}
												value={funPurUseNo}
												valueChanged={(value) => setFunPurUseNo(String(value))}
												
											/>
										</div>										
									</div>
								</div>
								
								<div className="fo-item">
									<p className="fo-key">발급내역</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizShortNm} valueChanged={(value) => setBizShortNm(String(value))} readOnly={true}/>
										
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">주담당자</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInput className={'tf tf-md tf-readonly2 w100p'} value={bizMainMangUserNm} readOnly={true} valueChanged={(value) => setBizMainMangUserNm(value)} />
											<Button color='gray-o' size="md" onClick={() => modalOpen('M')}>찾기</Button> 
											<button type="button" className="bt-refresh">리프레시</button>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서장</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInput className={'tf tf-md tf-readonly2 w100p'} value={bizDeptMangUserNm} readOnly={true} valueChanged={(value) => setBizDeptMangUserNm(value)} />
											<Button color='gray-o' size="md" onClick={() => modalOpen('D')}>찾기</Button>
											<button type="button" className="bt-refresh">리프레시</button>
										</div>
									</div>
								</div>
								
								<div className="fo-item">
									<p className="fo-key">발행키</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizShortNm} valueChanged={(value) => setBizShortNm(String(value))} readOnly={true}/>
										
									</div>
								</div>
								
								<div className="fo-item">
									<p className="fo-key">비고사항</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={notes} valueChanged={(value) => setNotes(value)} />
									</div>
								</div>
								
								<div className="fo-item">
									<p className="fo-key">등록자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={regUserNm} valueChanged={(value) => setRegUserNm(value)}  placeholder={'등록자'} readOnly={true}/>
									</div>						
								</div>
								<div className="fo-item">
									<p className="fo-key">등록일시</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={regDate} valueChanged={(value) => setRegDate(value)}  placeholder={'등록일시'} readOnly={true}/>
									</div>						
								</div>	

							</div> 
						</form>
						
						<div className="hz-root hz-right hz-gap5">
							<Button color='gray-o' size="sm" onClick={bizInfoCancel}>취소</Button>
							<Button color='pri-o' size="sm" onClick={bizInfoUpdate}>저장</Button>
							<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
						</div>

						<div className="hz-root hz-gap10">
						</div>
						
					</main>

				</div>
				{/* modal - 사용자검색 */}
				<ModalPopup
					open={modalIsOpen}
					title="사용자검색"
					size="lg"
					onClose={() => modalClose()}
					onAfterOpen={() => onAfterOpen()}
					
				>
					<div className="modal-con">
						<form className="sf sf-1row sf-2col mb30">
							<div className="inner">
								<div className="sf-item">
									<p className="sf-key">사용자유형</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<select name="tpCd" id="tpCd" onChange={handleSelect} >
												<option value="0">전체</option>
												<option value="1" selected>내부사용자</option>
											</select>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">이름</p>
									<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} valueChanged={(value) => setPersonNm(value)}  placeholder={'검색어 입력'} />
									</div>
								</div>
							</div>
							<button className="bt" data-color="pri" data-size="md" data-hz="" type="button" onClick={()=> doSearch('search')}>조회</button>
						</form>

						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
							<div className="hz-root hz-gap5">
								<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>

						<div id='sheetDiv' >[D] IBSHEET 영역</div>
				
						<div id="pageNavi" className="pg"></div>			

					</div>
				</ModalPopup>						
		</PageContainer>
	);
}
export default ContentsContainer;